<template>
  <svg
    :class="['h-6 w-6 stroke-current', classes]"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.8 50H37.2L50 37.2V14.8L37.2 2H14.8L2 14.8V37.2L14.8 50V50Z"
      stroke="#EB5757"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M26 43.0667V36.6667" stroke="#EB5757" stroke-width="4" />
    <path d="M26 32.4L26 8.93333" stroke="#EB5757" stroke-width="4" />
  </svg>
</template>
<script>
export default {
  props: {
    classes: {
      type: String,
      default: ""
    }
  }
}
</script>
